import { colors } from '@insurancemenu/imenu-components-lib';
import { createUseStyles } from 'react-jss';

const styles = {
  pageWrapper: {
    paddingBottom: '5rem',
  },
  tableWrapper: {
    backgroundColor: colors.neutral.white,
    borderRadius: '1rem',
    marginBottom: '7.2rem',
    overflow: 'hidden',
  },
  tableTitle: {
    textTransform: 'uppercase',
    letterSpacing: '0.1rem',
    font: { size: '1.8rem', lineHeight: '2.4rem', weight: 700 },
    color: colors.neutral[700],
  },
  tableBody: {
    boxSizing: 'border-box',
  },
  completeFormButton: {
    textTransform: 'uppercase',
    padding: '0 1.2rem',
    margin: '0 auto 2.5rem',
  },
  disableFormsButton: {
    color: colors.neutral.white,
    padding: '0 1.2rem',
    margin: '0 auto 2.5rem',
  },
};

const createStyles = createUseStyles(styles);

export { createStyles };
